import React from 'react'
import ReactDOM from 'react-dom/client'
// Self-hosted fonts — Instrument Sans for UI, IBM Plex Mono for amounts/codes
import '@fontsource-variable/instrument-sans';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';
import "./global.css";
import App from './App';
import { ThemeProvider } from './components/theme-provider';
import { useAuthStore } from './app/store/authStore';

// Initialize auth state from storage if available
const initializeAuth = (): void => {
  try {
    const storageValue = localStorage.getItem('auth-storage');
    if (storageValue) {
      const persistedState = JSON.parse(storageValue);
      if (persistedState?.state?.token) {
        useAuthStore.setState({ 
          token: persistedState.state.token, 
          isAuthenticated: true 
        });
      }
    }
    
    // Also check for authToken in localStorage for backward compatibility
    const authToken = localStorage.getItem('authToken');
    if (authToken && !useAuthStore.getState().isAuthenticated) {
      useAuthStore.setState({ 
        token: authToken, 
        isAuthenticated: true 
      });
    }
  } catch (e) {
    console.error("Failed to initialize auth state from storage:", e);
  }
};

// Call the initialization function
initializeAuth();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
      <App />
    </ThemeProvider>
  </React.StrictMode>
)
